export enum ContentType {
  POWERPOINT = 'powerpoint',
  WORD = 'word',
  VIDEO = 'video',
  TEXT = 'text',
  PDF = 'pdf'
}

export interface ContentFile {
  id: string;
  moduleId: string;
  fileName: string;
  fileType: ContentType;
  s3Key: string;
  size: number;
  uploadedAt: string;
}

export interface TrainingModule {
  id: string;
  title: string;
  description: string;
  contentFiles: ContentFile[];
  examId?: string;
  archived: boolean;
  archivedAt?: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
}

export interface QuestionOption {
  id: string;
  text: string;
}

export interface Question {
  id: string;
  examId: string;
  questionText: string;
  options: QuestionOption[];
  correctOptionId: string;
  order: number;
}

export interface Exam {
  id: string;
  moduleId: string;
  title: string;
  passRate: number;
  questions: Question[];
  createdAt: string;
  updatedAt: string;
}

export enum AssignmentStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  FLAGGED = 'flagged'
}

export interface ExamAttemptSummary {
  attemptNumber: number;
  score: number;
  passed: boolean;
  attemptedAt: string;
}

export interface Progress {
  contentViewed: boolean;
  lastAccessedAt?: string;
  examAttempts: ExamAttemptSummary[];
}

export interface TrainingAssignment {
  id: string;
  practitionerId: string;
  moduleId: string;
  moduleTitle?: string; // Optional field for enriched data
  assignedBy: string;
  assignedAt: string;
  status: AssignmentStatus;
  progress: Progress;
  attempts: number;
  maxAttempts: number;
  flagged: boolean;
  completedAt?: string;
}

export interface PractitionerListItem {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  assignedTrainings: number;
  completedTrainings: number;
  pendingTrainings: number;
  flaggedTrainings: number;
  lastActivity: string;
}

export interface DashboardSummary {
  totalPractitioners: number;
  pendingTrainings: number;
  completedTrainings: number;
  flaggedExams: number;
}

export interface SMTPConfig {
  host: string;
  port: number;
  secure: boolean;
  username: string;
  password: string;
  fromEmail: string;
  fromName: string;
}
